import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { TextButton } from "@swiggy-private/dls-web-core/dist/components/TextButton";

export const IMAGE_WIDTH = 58;
export const IMAGE_HEIGHT = Math.round(1.5 * IMAGE_WIDTH);

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const ImageWrapper = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: IMAGE_WIDTH,
    height: IMAGE_HEIGHT,
    marginTop: `calc(-1 * ${theme.spacing.xxSmall})`,
}));

export const Heading = styled(Text)(({ theme }) => ({
    marginBottom: theme.spacing.small,
    marginTop: theme.spacing.xSmall,
    textAlign: "center",
}));

export const Description = styled(Text)(({ theme }) => ({
    margin: theme.spacing.medium,
    marginTop: 0,
    marginBottom: `calc(${theme.spacing.xxxSmall} + ${theme.spacing.medium})`,
    textAlign: "center",
    lineHeight: "22px",
}));

export const ButtonWrapper = styled.div(({ theme }) => ({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing.small,
}));

export const CloseIconContainer = styled.div(({ theme }) => ({
    position: "absolute",
    top: theme.spacing.medium,
    right: theme.spacing.medium,
}));

export const TextButtonStyled = styled(TextButton)(({ theme }) => ({
    padding: "0",
    marginBottom: theme.spacing.small,
}));
